// extracted by mini-css-extract-plugin
export default {"searchInput":"Search_searchInput__mwG35","addressInput":"Search_addressInput__kA7G+","pinIcon":"Search_pinIcon__Q2WgI"};